import React from "react";
import { RangeSlider as InputSlider } from "@learningblocks/shared-components";
import cname from "../../Style/style.module.scss";

/**
 * RangeSlider:
 *  - Wrapper of storybook-components/RangeSlider
 *  - To be used in Widgets Content
 */
export function RangeSlider(props) {
  return (
    <InputSlider
      labelledby={props.labelledby}
      autoFocus={props.autoFocus}
      min={props.min}
      max={props.max}
      prevAria={props.prevAria}
      nextAria={props.nextAria}
      step={props.step}
      keyboardStep={props.keyboardStep}
      value={props.value}
      scaleInterval={props.scaleInterval}
      inputLabel={props.inputLabel}
      className={cname.input}
      onChange={props.onSliderChange}
    />
  );
}

RangeSlider.propTypes = InputSlider.propTypes;

RangeSlider.defaultProps = InputSlider.defaultProps;
